'use client'

import { T } from '@/components/t'
import { VideoSlider } from './jobs-video-slider'

const VIDEO_PATHS: Record<string, Record<string, string>> = {
    LONDON: {
        url: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/launch-parties/london_launch_party-MUubV7RgxRSCFftxwFUQmp6DxRy4os.mp4',
        thumbnail: '/_images/jobs/launch-parties/london_thumbnail.webp',
        ariaLabel: 'London launch party video',
    },
    AMSTERDAM: {
        url: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/launch-parties/amsterdam_launch_party-IQb1kpSYgm1N3jHJayr9h7M01oeb0D.mp4',
        thumbnail: '/_images/jobs/launch-parties/amsterdam_thumbnail.webp',
        ariaLabel: 'Amsterdam launch party video',
    },
    BERLIN: {
        url: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/launch-parties/berlin_launch_party-WNnzFTnTI3jjmYhpJ5E0GNvfa8aqhG.mp4',
        thumbnail: '/_images/jobs/launch-parties/berlin_thumbnail.webp',
        ariaLabel: 'Berlin launch party video',
    },
    COLOGNE: {
        url: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/launch-parties/cologne_launch_party-cc3kDqIa43MjEU1aAVfNgHX6A5mAul.mp4',
        thumbnail: '/_images/jobs/launch-parties/cologne_thumbnail.webp',
        ariaLabel: 'Cologne launch party video',
    },
    MALLORCA: {
        url: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/launch-parties/mallorca_offsite-CptZFisyPI77QnxKgPHbJ36anBRBQR.mov',
        thumbnail: '/_images/jobs/launch-parties/mallorca_thumbnail.webp',
        ariaLabel: 'Mallorca team event video',
    },
}

export const JobsLaunchPartiesSection = () => {
    return (
        <section className="flex w-full max-w-[2200px] flex-col items-center mb-4 md:mb-10">
            <div className="px-4 w-full flex justify-center">
                <T
                    h2
                    t="jobs.launchParties.title"
                    className="text-center text-[24px] md:text-[32px] mb-4 md:mb-10"
                />
            </div>
            <div>
                <VideoSlider videoPaths={VIDEO_PATHS} />
            </div>
            <div className="md:hidden w-dvw" />
        </section>
    )
}
